import executeQuery from "#lib/db"
import type { Photo } from "#types"

export const getPhotos = async ({ id }: { id: string }): Promise<Photo[]> => {
	const list = await executeQuery({
		query: `select * from photos where recipeID=${id}`,
	})

	return list.length > 0 ? list : []
}
